export const skills = [
  {
    id: '1',
    name: 'HTML',
    rate: 100,
    icon: require('../assets/html-5.png'),
    color: '#FC490B'
  },

  {
    id: '2',
    name: 'CSS',
    rate: 100,
    icon: require('../assets/css-3.png'),
    color: '#2196F3'
  },

  {
    id: '3',
    name: 'JavaScript',
    rate: 75,
    icon: require('../assets/js.png'),
    color: '#FFDF00'
  },

  {
    id: '4',
    name: 'TypeScript',
    rate: 60,
    icon: require('../assets/typescript.png'),
    color: '#3178C6'
  },

  {
    id: '5',
    name: 'ReactJS',
    rate: 60,
    icon: require('../assets/structure.png'),
    color: '#4DD0E1'
  },

  {
    id: '6',
    name: 'Git',
    rate: 60,
    icon: require('../assets/git.png'),
    color: '#FFE6E2'
  },

  {
    id: '7',
    name: 'Next.js',
    rate: 40,
    icon: require('../assets/nextjs.png'),
    color: '#FFFFFF'
  },

  {
    id: '8',
    name: 'React Native',
    rate: 50,
    icon: require('../assets/structure.png'),
    color: '#4DD0E1'
  },
]